import React from 'react';
import {Link} from 'react-router-dom';

interface IItem {
  label?: string;
  url?: string;
  action?: () => void;
}
interface BreadcrumbProps {
  items: Array<IItem>;
}
const BreadcrumbCusTom = ({items}: BreadcrumbProps) => {
  return (
    <nav className="text-gray-500 font-light m-0 p-0" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        {items.map((item, index) => (
          <li key={index} className="flex items-center text-gray-700 text-xs">
            {item.url ? (
              <Link
                to={item.url}
                className="text-inherit"
                onClick={() => item.action && item.action()}
              >
                {item?.label}
              </Link>
            ) : (
              <span className="text-inherit">{item?.label}</span>
            )}

            <span className="mx-2">{item?.url ? '/' : ''}</span>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbCusTom;
